import React from "react";
import {MenuAnchor} from "../HeaderStyled";
import loadable from "@loadable/component";

const Loading: React.FC = () => {
    return <MenuAnchor>MENU</MenuAnchor>;
};

export default loadable(() => import(/* webpackChunkName: 'nav' */ "../Nav"), {
    fallback: <Loading />,
});
